import { render, staticRenderFns } from "./OrderGroupingDetail.vue?vue&type=template&id=f1bcc6ca&scoped=true&"
import script from "./OrderGroupingDetail.vue?vue&type=script&lang=js&"
export * from "./OrderGroupingDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupingDetail.vue?vue&type=style&index=0&id=f1bcc6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bcc6ca",
  null
  
)

export default component.exports